import axios from 'axios';
import qs from 'qs';
import router from '../router';
import store from '../store';
import API_MAP from "../util/API_MAP";

const API_ERROR_WHITE_LIST = [API_MAP.REG_SUCCESS, API_MAP.FLIGHT_CITY];
const API_NO_LOADING_WHITE_LIST = [API_MAP.FLIGHT_CITY];

export default ({apiFactory, api, method, payload = {}, successCb, errorCb = ()=>{}, commit, ajaxConfig = {}, silentError = false}) => {
	if (API_NO_LOADING_WHITE_LIST.indexOf(api) === -1) {
		commit('main/setLoadingStatus', true, { root: true });
	}
	let axiosOption = {
		baseURL: '/api',
		method: method || 'get',
		url: api,
		withCredentials: true,
		headers: {}
	};
	if (method.toLowerCase() === 'get') {
		axiosOption.params = payload;
	}
	if (method.toLowerCase() === 'post') {
		axiosOption.headers = { 'content-type': 'application/x-www-form-urlencoded' }
		axiosOption.data = qs.stringify(payload);
	}
	if (method.toLowerCase() === 'json') {
		axiosOption.method = 'post';
		axiosOption.data = payload;
	}
	if (method.toLowerCase() === 'file') {
		axiosOption.method = 'post';
		axiosOption.headers = { 'content-type': 'multipart/form-data' };
		axiosOption.data = payload;
	}
	axiosOption.headers.source = 'reg';
	axios(axiosOption)
		.then(function (response) {
			const language = store.state.main.language;
			response = response.data;
			if (!response.code) {
				throw {
					message: '响应结果格式异常，无 Code'
				};
			}
			if (response.code.toString() === '200') {
				successCb(response.data || {});
			} else if (response.code.toString() === '101' || response.code.toString() === '102') {
				errorCb(response);
			} else if (response.code.toString() === '103') {
				if (language === 'zh') {
					router.push('/reset');
				} else {
					router.push('/en/reset');
				}
			} else if (response.code.toString() === '401') {
				commit('main/setLoginStatus', false, { root: true });
				commit('main/setCurrentUser', {}, { root: true });
				errorCb(response.data);
				// 判断是否在登录页（兼容开发和生产环境）
				const isLoginPage = location.pathname === '/login' ||
					location.pathname === '/en/login' ||
					location.pathname === '/reg/login' ||
					location.pathname === '/reg/en/login';
				if(!isLoginPage) {
					// commit('main/openMessage', {
					// 	type: 'warning',
					// 	message: '登录失效或过期，请登录'
					// }, { root: true });
					if (language === 'zh') {
						router.push('/login');
					} else {
						router.push('/en/login');
					}
				}
			} else {
				errorCb(response.data);
				if (API_ERROR_WHITE_LIST.indexOf(axiosOption.url) !== -1) {
					return;
				}
				commit('main/openMessage', {
					type: 'error',
					message: response.message
				}, { root: true });
			}

		})
		.catch(function (error) {
			errorCb(error);
			if (API_ERROR_WHITE_LIST.indexOf(axiosOption.url) !== -1) {
				return;
			}
			// 如果设置了静默错误，则不弹出提示
			if (!silentError) {
				commit('main/openMessage', {
					type: 'error',
					message: error.message
				}, { root: true });
			}

		})
		.then(function () {
			commit('main/setLoadingStatus', false, { root: true });
		});
}